/**
 * @file rollout.ts
 * @description Rollout (release toggles) — Statsig behind OpenFeature. The CLIENT
 * key is public (ships in the bundle) and per-environment, so a given build can
 * only ever receive its own environment's resolved gates (no cross-env pollution).
 * Mirrors customer/app's config.rollout; the marketing site has no central config
 * object, so the wiring lives here.
 */

/**
 * Map VITE_ENV (dev/staging/prod spellings) to a Statsig environment tier. The
 * tier tags the SDK init so gates resolve for exactly this environment.
 */
function statsigTier(
  env: string | undefined,
): 'development' | 'staging' | 'production' {
  const e = (env ?? 'development').toLowerCase()
  if (e.startsWith('prod')) return 'production'
  if (e.startsWith('stag') || e === 'int') return 'staging'
  return 'development'
}

export const rollout = {
  /** Statsig client SDK key for this environment (public). Empty = rollout off. */
  statsigClientKey: import.meta.env.VITE_STATSIG_CLIENT_KEY ?? '',
  /** Statsig environment tier, derived from VITE_ENV. */
  tier: statsigTier(import.meta.env.VITE_ENV),
} as const
